<template>
  <div class="examination" @mouseup.prevent="">
    <!-- 标头 -->
    <div class="header">
      <div class="solid-btn" style="--bgc: #ffb842; --bsc: #c0811f;" @mouseup="leavebtn">{{ $t("studentProgramme.leave") }}</div>
      <span class="title"> {{ questionInfo.number }}</span>
      <!-- 填充节点 -->
      <span class="empty"></span>
    </div>

    <!-- 主体 -->
    <div class="container">
      <div class="question-nav" tabindex="1" @touchstart.self="questionFocus" ref="question">
        <div class="question-box" v-if="mode == 'question'">
          <!-- circle: 答题通用样式
            cur-answer: 在答题中
            use-answer: 已答题完 -->
          <div :class="['circle',
            item.status == '1' && 'cur-answer',
            item.status == '2' && 'use-answer']"
               v-for="(item, idx) in questionList" :key="idx" @click="clickTopic(idx)">{{ item.key }}</div>
        </div>
        <div class="question-box" v-else>
          <!-- result: 查看答案通用样式
            cur-result: 当前查看的题
            success: 答对的题
            error: 答错的题 -->
          <div v-for="(item, idx) in questionList" :key="idx" @click="clickTopic(idx)"
               :class="['result',
              item.true_flase,
              idx == curQuestion && 'cur-result']"
          >{{ item.key }}</div>
        </div>
      </div>

      <div class="quesion-main" @click.prevent="">
        <div class="main" :style="`height: ${isPC() && '100%'};`">
          <div class="main-header">
            <div class="left">
              <div class="topic">{{ $t("studentProgramme.question") }}{{ curQuestion + 1 }}</div>
              <div class="tip">{{ form && form.score }}{{ $t("studentProgramme.score") }}</div>
              <div class="question-no">{{ $t("studentProgramme.questionNo") }}{{ form && form.question_no }}</div>
            </div>
<!--            <div v-if="mode == 'viewAnswer'">-->
<!--              <div class="result-icon" v-if="questionList[curQuestion].true_flase == 'success'">-->
<!--                <div class="correct"></div>-->
<!--              </div>-->
<!--              <div class="result-icon" v-else>-->
<!--                <div class="wrong"></div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="right" style="width: 100%">
<!--              <div class="solid-btn disabled" v-if="curQuestion < (questionList.length - 1) && nextQuestionSwitch && mode == 'question'" style="&#45;&#45;bgc:#dcdbdc; &#45;&#45;bsc: #979797; &#45;&#45;textc: #9b9b9b">跳過</div>-->
<!--              <div class="solid-btn" style="&#45;&#45;bgc:#ffb842; &#45;&#45;bsc: #c0811f;"-->
<!--                   v-else-if="curQuestion < (questionList.length - 1) && mode == 'question'" @click="skip">跳過</div>-->
<!--              <div class="solid-btn disabled" v-if="!nextQuestionSwitch && mode == 'question'" style="&#45;&#45;bgc:#dcdbdc; &#45;&#45;bsc: #979797; &#45;&#45;textc: #9b9b9b">重置</div>-->
<!--              <div class="solid-btn" style="&#45;&#45;bgc:#ffb842; &#45;&#45;bsc: #c0811f;"-->
<!--                   v-else-if="mode == 'question'" @click="resetting">重置</div>-->
<!--              <div class="solid-btn" style="&#45;&#45;bgc:#ffb842; &#45;&#45;bsc: #c0811f;" v-if="curQuestion != 0 && mode == 'viewAnswer'" @click="prevQuestion">上一題</div>-->
<!--              <div class="solid-btn disabled" v-if="curQuestion < (questionList.length - 1) && !nextQuestionSwitch" style="&#45;&#45;bgc:#dcdbdc; &#45;&#45;bsc: #979797; &#45;&#45;textc: #9b9b9b">下一題</div>-->
<!--              <div class="solid-btn" style="&#45;&#45;bgc:#ffb842; &#45;&#45;bsc: #c0811f;"-->
<!--                   v-else-if="curQuestion < (questionList.length - 1)" @click="nextQuestion">下一題</div>-->
            </div>
          </div>

          <!--  -->
          <div class="body" v-if="form"
               v-loading="loading" element-loading-background="#fff" element-loading-text="loading"
               :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`} ${isPC() ? 'flex: 1;' : ''}`"
               tabindex="2" @touchstart.self="bodyFocus" ref="body">
            <div class="before" v-if="loading"></div>


            <ChoiceEcho ref="ChoiceEcho" @urlToParent="urlToParent" @permissions="permissions" v-if="form.type == 0" :mode="mode" :form="form"></ChoiceEcho>
            <DetermineEcho ref="DetermineEcho" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 1" :mode="mode"  :form="form"></DetermineEcho>
            <FillingBlanksEcho ref="FillingBlanksEcho" @repariRecordQuestion="repariRecordQuestion" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 2" :mode="mode"  :form="form"></FillingBlanksEcho>
            <MatrimFillEcho ref="MatrimFillEcho" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 10" :mode="mode"  :form="form"></MatrimFillEcho>
            <SumEcho ref="SumEcho" @permissions="permissions" v-else-if="form.type == 3 || form.type == 8" :mode="mode"  :form="form"></SumEcho>
            <HotspotEcho ref="HotspotEcho" @permissions="permissions" v-else-if="form.type == 4" :mode="mode"  :form="form"></HotspotEcho>
            <TextDragEcho ref="TextDragEcho" @permissions="permissions" v-else-if="form.type == 5" :mode="mode"  :form="form"></TextDragEcho>
            <LigatureEcho ref="LigatureEcho" @permissions="permissions" v-else-if="form.type == 6" :mode="mode"  :form="form"></LigatureEcho>
            <ImgDragEcho ref="ImgDragEcho" @permissions="permissions" v-else-if="form.type == 7" :mode="mode"  :form="form"></ImgDragEcho>
            <TextDragEcho2 ref="TextDragEcho2" @permissions="permissions" v-else-if="form.type == 9" :mode="mode"  :form="form"></TextDragEcho2>
          </div>

          <!-- 查看答案功能 -->
          <div class="viewAnswer-func">
            <div class="viewAnswer-func" style="justify-content: left;">
              <div class="solid-btn disabled" v-if="curQuestion < (questionList.length - 1) && !nextQuestionSwitch" style="--bgc:#dcdbdc; --bsc: #979797; --textc: #9b9b9b">{{ $t("studentProgramme.nextQuestion") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;"
                   v-else-if="curQuestion < (questionList.length - 1)" @click="nextQuestion">{{ $t("studentProgramme.nextQuestion") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" v-if="curQuestion != 0 && mode == 'viewAnswer'" @click="prevQuestion">{{ $t("studentProgramme.previousQuestion") }}</div>
              <div class="reference">
                <div class="solid-btn" v-if="form.explanation" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showAnswering">{{ $t("studentProgramme.solutionApproach") }}</div>
                <div class="empty" v-else></div>
                <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showReference">{{ $t("studentProgramme.answers") }}</div>
              </div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showIssues">{{ $t("studentProgramme.issue") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 子组件 -->
    <LeaveDialog @closeDialog="leaveSwitch = false" :leaveMessage="leaveMessage" v-if="leaveSwitch"></LeaveDialog>
    <ConfirmSubmit @closeDialog="confrimSwitch = false" @confirm="complete" v-if="confrimSwitch"></ConfirmSubmit>
    <AnsweringDialog :explanation="form.explanation" @closeDialog="answeringSwitch = false" v-if="answeringSwitch"></AnsweringDialog>
    <IssuesDialog :id="form.id" @closeDialog="issuesSwitch = false" v-if="issuesSwitch"></IssuesDialog>
    <QuizDialog v-if="false"></QuizDialog>
    <ShowBigPhoto v-if="showBigPhotoSwitch" :url="imageUrl" @close="closeShowBigPhoto"></ShowBigPhoto>
    <!-- 预览弹窗 -->
    <DialogPreview v-if="referenceSwitch" :form="form" @close="referenceSwitch = false"
                   :recordData="recordQuestionList[curQuestion]"></DialogPreview>

    <Complete :answerResults="answerResults" @close="viewAnswer" v-if="completeSwitch"></Complete>
  </div>
</template>

<script>
// iscroll-probe专业版本，可以监听滚动的位置等细节
import IScroll from 'iscroll/build/iscroll-probe'

import transform from './static/transition.js'

import { getAssessments } from '@/api/assessment.js'
import { getAnswerResultsDetail } from '@/api/answerResult.js'
import { getPractisesDetailByAnswer } from '@/api/practise.js'
import { getTopicsTest } from '@/api/topic.js'
import { toSnakeCase } from '@/utils/data-format.js'
import { getChildOffsetRelativeToParent } from '@/utils/scroll-to.js'
import answersTrueFalse from './static/answersTrueFlase.js'

let clickQuestThrottle = null,
    intervalTime = 1000

export default {
  components: {
    ...transform,
  },
  data() {
    return {
      convertType: [
        'ChoiceEcho',
        'DetermineEcho',
        'FillingBlanksEcho',
        'SumEcho',
        'HotspotEcho',
        'TextDragEcho',
        'LigatureEcho',
        'ImgDragEcho',
        'SumEcho',
        'TextDragEcho2',
        'MatrimFillEcho',
      ],
      // 题目列表
      questionList: [],
      // 课题信息
      questionInfo: {},

      // 模式：答题模式 question, viewAnswer
      mode: 'viewAnswer',
      echo: 'FillingBlanksEcho',
      curQuestion: 0,
      form: null,

      // 展示图地址
      imageUrl: '',

      leaveMessage: '',
      // 组件开关
      leaveSwitch: false,
      confrimSwitch: false,
      answeringSwitch: false,
      issuesSwitch: false,
      completeSwitch: false,
      nextQuestionSwitch: true,
      showBigPhotoSwitch: false,
      referenceSwitch: false,

      // 提交学生填写的答案
      results: {
        topic_id: null,
        grade_id: null,
        answer_results: []
      },
      // 本地处理学生填写的答案
      recordQuestionList: [],
      answerResults: null,
      iscroll: null,

      loading: true,
      isFullscreen: false,
    }
  },
  watch: {
    curQuestion: function() {
      this.curQuestionNumberTop()
    }
  },
  methods: {
    leavebtn() {
      if(this.mode == 'question') {
        this.leaveMessage = this.$t("studentProgramme.leaveText")
      } else {
        this.leaveMessage = ''
      }
      this.leaveSwitch = true
    },
    questionFocus() {
      this.$refs.question.focus()
    },
    bodyFocus() {
      this.$refs.body.focus()
    },
    isPC() {
      // Safari
      // if(navigator.userAgent.match('Safari')) return true
      if (window.matchMedia("(max-width: 1080px)").matches) { // 可以根据需要设置不同的断点
        return false;
      }
      return true;
    },
    // 左侧题号根据当前题目,定位于顶部
    curQuestionNumberTop() {
      let curQuestion = (this.curQuestion - 1) < 0 ? 0 : this.curQuestion - 1,
          questionNav = document.querySelector('.question-nav'),
          circle = questionNav.querySelectorAll(this.mode == 'question' ? '.circle' : '.result')[curQuestion]
      //console.info(curQuestion, circle)

      let position = getChildOffsetRelativeToParent(circle, questionNav)

      questionNav.scrollTop += position.top - (this.mode == 'question' ? 20 : 15)
      //console.info('position', position.top)
    },
    // 关闭图片展示
    closeShowBigPhoto() {
      this.showBigPhotoSwitch = false
    },
    // 更新题目
    repariRecordQuestion(recordQuestion, limit = 0) {
      this.recordQuestionList[this.curQuestion] = JSON.parse(JSON.stringify(recordQuestion))
      this.questionList[this.curQuestion].limit = limit
    },
    // 子组件将展示图片地址传输到父组件
    urlToParent(img) {
      this.showBigPhotoSwitch = true
      this.imageUrl = img
    },
    // 重置考题
    resetting() {
      let echo = this.convertType[this.form.type]
      let child = this.$refs[echo]
      child.resetting()
    },
    // 开放下一题按钮 权限
    permissions(open) {
      if(this.mode == 'question') {
        this.nextQuestionSwitch = open
      } else {
        this.nextQuestionSwitch = true
      }
    },
    // 获取学生答案
    getStudentAnswer() {
      let child = null

      // child.answer_results.student_choices = this.results.answer_results[this.curQuestion].student_choices
      // child.answer_results = this.results.answer_results[this.curQuestion]
      if(child.limit != 0) {
        this.questionList[this.curQuestion].status = '2'
      } else {
        this.questionList[this.curQuestion].status = '0'
      }
      this.questionList[this.curQuestion].limit = child.limit

      this.recordQuestionList[this.curQuestion] = JSON.parse(JSON.stringify(child.recordQuestion))
      if(JSON.stringify(this.results.answer_results[this.curQuestion].student_choices)
          != JSON.stringify(child.answer_results) && child.answer_results.student_choices.length != 0) {
        if(child.answer_results.student_choices != ''){
          this.results.answer_results[this.curQuestion] = (child.answer_results)
        }
      }
      let result = answersTrueFalse(child.recordQuestion, child.answer_results, this.form)
      this.questionList[this.curQuestion].trueFlase = result ? 'success' : 'false'
      //alert(this.questionList[this.curQuestion].trueFlase);
    },
    // 点击题目
    clickTopic(key) {
      /// 节流判断
      if(clickQuestThrottle != null){
        return ;
      }
      clickQuestThrottle = setTimeout(() => {
        clickQuestThrottle = null
      }, intervalTime)

      this.loading = true
      if(this.mode == 'question') {
        // 已读的题目才能侧边栏点击
        if(!this.questionList[key].isRead) {
          this.loading = false
          return ;
        }
        this.getStudentAnswer()
      }
      let echo = this.convertType[this.form.type]
      let child = this.$refs[echo]
      child.answer_results.id = this.form.id
      if(child.limit != 0) {
        this.questionList[this.curQuestion].status = '2'
      } else {
        this.questionList[this.curQuestion].status = '0'
      }

      this.curQuestion = key
      this.questionList[this.curQuestion].status = '1'
      this.form = {}
      setTimeout(() => {
        this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
        //console.info(this.form)
        if(this.mode == 'question') {
          if(this.form.limit > 0) this.nextQuestionSwitch = true
          else this.nextQuestionSwitch = false
        } else {
          this.nextQuestionSwitch = true
        }
        this.answerReview()
      }, 200);
    },
    // 上一题
    prevQuestion() {
      this.loading = true
      this.curQuestion--
      this.questionList.filter((item, idx) => {
        if(this.curQuestion > idx) item.status = '2'
        else if(this.curQuestion == idx) item.status = '1'
      })
      this.form = {}
      setTimeout(() => {
        this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
        this.answerReview()
      }, 200);
    },
    // 跳过
    skip() {
      this.loading = true
      if(this.mode == 'question')
        this.getStudentAnswer()
      this.curQuestion++
      this.form = {}
      //console.info(this.curQuestion)
      this.questionList[this.curQuestion].status = '1'
      this.questionList[this.curQuestion].isRead = true

      setTimeout(() => {
        this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
        if(this.mode == 'question') {
          if(this.form.limit > 0) this.nextQuestionSwitch = true
          else this.nextQuestionSwitch = false
        } else {
          this.nextQuestionSwitch = true
        }
        this.answerReview()
      }, 200);
    },
    // 下一题
    nextQuestion() {
      this.loading = true
      if(this.mode == 'question')
        this.getStudentAnswer()
      this.curQuestion++
      this.form = {}
      this.questionList[this.curQuestion].status = '1'
      this.questionList[this.curQuestion].isRead = true
      setTimeout(() => {
        this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
        if(this.mode == 'question') {
          if(this.form.limit > 0) this.nextQuestionSwitch = true
          else this.nextQuestionSwitch = false
        } else {
          this.nextQuestionSwitch = true
        }
        this.answerReview()
      }, 200);
    },
    answerReview() {
      setTimeout(() => {
        /*// eslint-disable-next-line no-debugger
        // debugger;*/
        let echo = this.convertType[this.form.type]
        let child = this.$refs[echo]
        child.limit = this.form.limit
        if(this.recordQuestionList[this.curQuestion]) {
          child.recordQuestion = JSON.parse(JSON.stringify(this.recordQuestionList[this.curQuestion]))
          child.limit = this.form.limit
        }
      }, 200)
      // }
    },

    // 查看答案
    viewAnswer() {
      this.completeSwitch = false
      this.nextQuestionSwitch = true
      this.loading = true
      this.curQuestion = 0
      this.form = null
      setTimeout(() => {
        this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
        document.querySelector('.question-nav').scrollTop = 0
        this.mode = 'viewAnswer'
        this.answerReview()
      }, 200)
    },

    // 解题思路
    showAnswering() {
      this.answeringSwitch = true
    },

    // 参考答案
    showReference() {
      this.referenceSwitch = true
    },

    // 回报问题
    showIssues() {
      this.issuesSwitch = true
    },

    // 随机筛选题目
    randomQuestion(res) {
      // 强制设置为不随机
      res.data.isRandom = 0
      let _ = require('lodash');
      /**
       * randomNumbe：抽取数量 （小于等于0） 取全部
       * isRandom：true（打乱数据），false（原始数据）
       */
      let randomData
      // 是否随机
      if(res.data.isRandom) {
        randomData = _.shuffle(res.data.questions)
      } else {
        randomData = res.data.questions
      }
      let extractData = []
      // 抽取
      if(res.data.isRandom && res.data.randomNumber && res.data.randomNumber < randomData.length && res.data.randomNumber > 0) {
        // 获取抽取的索引
        let fillIdxs = []
        for(let i = 0; i < randomData.length;) {
          if(fillIdxs.length < res.data.randomNumber) {
            let rNum = Math.floor(Math.random() * (randomData.length))
            if(!fillIdxs.includes(rNum)) {
              fillIdxs.push(rNum)
              i++
            }
          } else break
        }
        // randomData根据fillIdxs中的索引 将数据追加到extractData中
        fillIdxs.sort((a, b) => a - b)
        fillIdxs.filter(its => {
          extractData.push(randomData[its])
        })
      } else {
        extractData = randomData
      }

      return extractData
    },
    handleExplanation(form) {
      form.explanation = form.explanation.split('-----')[0]
    },

    // 默认添加所有题
    defaultAddQuestion() {
      let { questionList } = this

      for(let i = 0; i < questionList.length; i++) {
        let its = questionList[i]
        if(i == 0) {
          its.isRead = true
        } else {
          its.isRead = false
        }
        this.results.answer_results[i] = {
          id: its.id,
          student_choices: []
        }
      }
      this.answerReview();
    },

    isScrollSelf() {
      //console.info(this.$refs.wrapper)
      this.iscroll = new IScroll(this.$refs.wrapper, {
        mouseWheel: false,
        scrollbars: false, // 是否显示滚动条
        probeType: 3, //  像素级的触发scroll事件
        // 解决拖拽卡顿问题
        scrollX: false,
        scrollY: true
        // disablePointer: true,
        // disableTouch: false,
        // disableMouse: true
      })
    },
    getAnswerResultsDetail(){
      let {answerResultId} = this.$route.query
      getAnswerResultsDetail(answerResultId).then(res => {
        // eslint-disable-next-line no-debugger
        debugger;
        // 学生的答案
        let answerResultQuestions = res.data.answerResultQuestions;
        this.questionList = toSnakeCase(this.questionList);
        // 把答案放入
        for(let i = 0; i < this.questionList.length; i++) {
          for(let j = 0; j < answerResultQuestions.length; j++) {
            if(this.questionList[i].id == answerResultQuestions[j].questionId){
              console.info('answerResultQuestions[j].score:'+answerResultQuestions[j].score);
              if(answerResultQuestions[j].score >0){
                this.questionList[i].true_flase = 'success'
              }else{
                this.questionList[i].true_flase = 'error'
              }
              console.info("this.questionList"+this.questionList[i].true_flase);
            }
          }
        }

        this.clickTopic(0)
        this.defaultAddQuestion()
      })
    },
    initData() {
      let {id, type, topicId, isSmallTest, gradeId,questionListIds,answerValues} = this.$route.query
      // 评估 assessments, 作业 work, 冒险(课题，小测) adventure, 图书馆(練習) library
      this.recordQuestionList = JSON.parse(answerValues)
      this.results.topic_id = topicId || id
      // 处理类型
      if(isSmallTest != undefined) {
        type = isSmallTest == 'false' ? 'library' : 'adventure'
      }

      if(type == 'assessments') {
        getAssessments({gradeId}).then(res => {
          let data = this.randomQuestion(res)
          res.data.number = res.data.gradeName + '評估'
          data.filter((its, idx) => {
            if(idx == 0) its['status'] = 1
            else its['status'] = 0
            its['trueFlase'] = 'error'
            its['key'] = idx + 1
          })
          this.questionList = toSnakeCase(data)
          this.questionList.filter(its => this.handleExplanation(its))

          this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
          delete res.data.questions
          this.questionInfo = res.data
          this.defaultAddQuestion()
        }).catch(err => {
          if (err.response.status === 401) {
            this.initData()
          }
        })
      }else if(type == 'library') {
        let answerForm = {
          id,
          questionListIds
        }
        // eslint-disable-next-line no-debugger
        debugger;
        getPractisesDetailByAnswer(answerForm).then(res => {
          let data = this.randomQuestion(res)
          data.filter((its, idx) => {
            if(idx == 0) {
              its['status'] = 1
            }else {
              its['status'] = 0
            }
            its['trueFlase'] = 'error'
            its['key'] = idx + 1
          })
          // 轉成下劃線風格
          this.questionList = toSnakeCase(data)

          this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
          delete res.data.questions
          this.questionInfo = res.data
          this.questionInfo.number = this.questionInfo.number || '练习'
          this.defaultAddQuestion()
        })
      } else if(type == 'adventure') {
        getTopicsTest(id).then(res => {
          window.sessionStorage.lastLearningTopiceId = topicId
          let data = this.randomQuestion(res)
          data.filter((its, idx) => {
            if(idx == 0) its['status'] = 1
            else its['status'] = 0
            its['trueFlase'] = false
            its['key'] = idx + 1
          })
          this.questionList = toSnakeCase(data)
          this.questionList.filter(its => this.handleExplanation(its))

          this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
          delete res.data.questions
          this.questionInfo = res.data
          this.questionInfo.number = this.questionInfo.number || '小測'
          this.defaultAddQuestion()
        }).catch(err => {
          if (err.response.status === 401) {
            this.initData()
          }
        })
      }
      this.answerReview()

      setTimeout(() => {
        this.getAnswerResultsDetail() // 你要延迟执行的方法
      }, 1000) // 1000毫秒 = 1秒
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    // this.isScrollSelf()
  }
}
</script>

<style scoped lang="scss">
.examination {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  // z-index: 9999;
  .solid-btn {
    padding: 0 20px;
    height: 35px;
    line-height: 25px;
    border-radius: 18px;
    background-color: var(--bgc);
    color: var(--textc, #333);
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    padding-top: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 10px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      box-shadow: inset 0px -4px 1px 0 var(--bsc);
    }

    &:hover {
      opacity: .7;
    }
  }

  .header {
    width: 100%;
    height: 50px;
    background-color: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.10);
    position: relative;

    & > img {
      height: 35px;
      width: auto;
      cursor: pointer;

      &:hover {
        opacity: .7;
      }
    }

    .title {
      font-size: 16px;
    }

    .empty {
      height: 1px;
      width: 67px;
    }
  }

  .container {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    background-color: #fff;
    // overflow-y: auto;

    .question-nav {
      width: 100px;
      height: 100%;
      background: #f6a053;
      padding: 20px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .question-box {
        width: 100%;
        //min-height: 101%;
        display: flex;
        justify-content: center;
        align-content: flex-start;
        flex-wrap: wrap;
        box-sizing: border-box;

        // position: static;
      }

      .circle {
        width: 40px;
        height: 40px;
        background-color: #fcd8b5;
        color: #333;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        font-weight: 700;

        &:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 10px;
          background-color: #fff;
          bottom: -15px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      .circle:nth-last-of-type(1) {
        //margin-bottom: 70px;
        &:before {
          content: none;
        }
      }
      .use-answer {
        background-color: #f46b40;
        color: #fff;

        &::before {
          background-color: #f46b40;
        }
      }

      .cur-answer {
        background-color: #e34f34;
        color: #fff;
      }

      .result {
        width: 40px;
        height: 40px;
        background-color: #f46b40;
        color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        font-weight: 700;
        box-shadow: 0 5px 1px 1px #d55c37;
      }

      .result:nth-last-of-type(1) {
        margin-bottom: 70px;
      }

      .cur-result {
        background-color: #e34f34;
        box-shadow: 0 5px 1px 1px #b84732;
      }

      .success {
        &:before {
          content: '';
          position: absolute;
          bottom: calc(100% - 20px);
          left: 100%;
          width: 20px;
          height: 20px;
          background-image: url('../../assets/images/circle-success.png');
          background-size: 100% 100%;
          border-radius: 50%;
        }
      }

      .error {
        &:before {
          content: '';
          position: absolute;
          bottom: calc(100% - 20px);
          left: 100%;
          width: 20px;
          height: 20px;
          background-image: url('../../assets/images/circle-error.png');
          background-size: 100% 100%;
          border-radius: 50%;
        }
      }


    }

    .quesion-main {
      width: calc(100% - 100px);
      height: 100%;
      padding: 20px 20px 10px 20px;
      box-sizing: border-box;
      overflow-y: auto;

      .main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .main-header {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .left {
            width: 100%;
            display: flex;
            align-items: center;

            .topic {
              color: #DE5934;
              font-size: 26px;
              font-weight: 700;
              margin-right: 15px;
            }

            .tip {
              margin-right: 10px;
              background-color: #ea6f57;
              color: #fff;
              font-size: 16px;
              padding: 7px 15px;
              border-radius: 5px;
            }

            .question-no {
              margin-right: 10px;
              color: #666;
              font-size: 16px;
              border-radius: 5px;
            }
          }

          .result-icon {
            margin-right: 70px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 40px;

            .icon {
              width: 40px;
              height: auto;
              margin-right: 10px;
            }

            // .correct {
            //   width: 120px;
            //   height: 60px;
            //   background-image: url('../../assets/images/results_correct.png');
            //   background-repeat: no-repeat;
            //   background-size: 240px 110px;
            //   background-position: -98px -38px;
            //   animation: wrong .7s steps(2), wrong02 .7s steps(1);
            // }

            .correct{
              animation: test1 1.5s steps(1, end);
              width: 140px;
              height: 40px;
              background-image: url("../../assets/images/results_correct.png");
              background-size: 150px auto;
              background-repeat: no-repeat;
              background-position: -5px -246px;
              margin: 0 5px;
            }

            @keyframes test1
            {
              0% {background-position: -5px -12px;}
              25% {background-position: -5px -70px;}
              50% {background-position: -5px -128px;}
              75% {background-position: -5px -187px;}
              100% {background-position: -5px -246px;}
            }

            .wrong {
              width: 140px;
              height: 40px;
              background-image: url('../../assets/images/results_wrong.png');
              background-repeat: no-repeat;
              background-size: 150px auto;
              background-position: -5px -152px;
              margin: 0 5px;
              animation: wrong 1.5s steps(1, end);
            }

            @keyframes wrong {
              0% {background-position: -5px -12px;}
              25% {background-position: -5px -58px;}
              50% {background-position: -5px -108px;}
              75% {background-position: -5px -152px;}
            }

            .text-tip {
              color: var(--textc, #008000);
              font-size: 22px;
              font-weight: 700;
            }

            .fraction {
              margin-left: 10px;
              color: #8E8E8E;
              font-weight: 700;
              font-size: 16px;
            }
          }

          .right {
            width: 100%;
            display: flex;
            justify-content: flex-end;

            & > img {
              height: 28px;
              width: auto;
              margin-left: 10px;
              cursor: pointer;

              &:hover {
                opacity: .7;
              }
            }

            .disabled {
              cursor: not-allowed;

              &:hover {
                opacity: 1;
              }
            }
          }
        }
        .body {
          flex: 1;
          width: 100%;
          background-color: #fff6ec;
          border-radius: 15px;
          position: relative;
          overflow-y: auto;
          box-sizing: border-box;
          font-family: 'TimesNewRoman', sans-serif;

          .before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #fff;
            z-index: 999;
          }
        }

        .viewAnswer-func {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          //& > * {
          //  margin: 0;
          //}

          div:nth-of-type(1) {
            font-weight: 700;
          }

          .reference {
            display: flex;
          }

          .return-issues {
            border: 2px solid #ffb842;
            border-radius: 50px;
            padding: 2px 15px;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;

            &:hover {
              opacity: .7;
            }
          }
        }
      }
    }
  }
  .filler-particle {
    width: 100%;
    height: 30px;
  }
}
</style>

<style lang="scss">
.examination {
  .determine-success {
    border: 2px solid #007416 !important;
    position: relative !important;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: -40px;
      bottom: 0;
      margin: auto;
      width: 20px;
      height: 11px;
      border: 4px solid #007416;
      border-top: none;
      border-right: none;
      border-radius: 2px;
      transform: rotateZ(-45deg);
    }
  }

  .determine-error {
    border: 2px solid #d60215 !important;
    position: relative !important;

    &:after ,&:before {
      content: '';
      position: absolute;
      top: 0;
      right: -40px;
      bottom: 0;
      margin: auto;
      background-color: #d60215;
      width: 20px;
      height: 4px;
      transform-origin: center center;
      transform: rotateZ(-45deg);
      border-radius: 20px;
    }

    &:before {
      transform: rotateZ(45deg);
    }
  }

  .determine-error-br {
    border: 2px solid #d60215 !important;
    position: relative !important;

    &:before {
      content: '';
      position: absolute;
      bottom: -6px;
      right: -6px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../assets/images/circle-error.png');
      background-size: 100% 100%;
      // z-index: 1;
    }
  }

  .determine-success-br {
    border: 2px solid #007416 !important;
    position: relative !important;

    &:before {
      content: '';
      position: absolute;
      bottom: -6px;
      right: -6px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../assets/images/circle-success.png');
      background-size: 100% 100%;
      // z-index: 1;
    }
  }

  .question-view {
    height: fit-content !important;

    .block-style {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 80px;
      left: 80px;
      cursor: pointer;
      // z-index: 1;
      background-size: 100% 100%;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px dashed #333;
      }

      .success, .error {
        position: absolute;
        bottom: -5px;
        right: -5px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #007416;
        display: none;
      }

      .success {
        &:before {
          content: '';
          color: #fff;
          position: absolute;
          top: -5px;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 10px;
          height: 6px;
          border: 2px solid #fff;
          border-top: none;
          border-right: none;
          transform: rotateZ(-50deg);
          transform-origin: center center;
        }
      }

      .error {
        background-color: #d60215;

        &:before, &:after {
          content: '';
          width: 10px;
          height: 2px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          transform: rotateZ(-45deg);
          transform-origin: center center;
          background-color: #fff;
        }

        &:after {
          transform: rotateZ(45deg);
        }
      }
    }

    .block-style-success {
      &:before {
        content: '';
        border-width: 2px !important;
        border-color: #007416 !important;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-image: url('../../assets/images/circle-success.png');
        background-size: 100% 100%;
      }
    }

    .block-style-error {
      &:before {
        content: '';
        border-width: 2px;
        border-color: #d60215;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-image: url('../../assets/images/circle-error.png');
        background-size: 100% 100%;
      }
    }
  }

  .img-drag {

    .block-style {
      &:before {
        content: '';
        color: #eeeeee; /* 文字颜色，可按需修改 */
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px dashed #8f9298;
      }
    }

    .block-style-success {
      &:before {
        content: '';
        border-width: 2px !important;
        border-color: #007416 !important;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-image: url('../../assets/images/circle-success.png');
        background-size: 100% 100%;
      }
    }

    .block-style-error {
      &:before {
        content: '';
        border-width: 2px;
        border-color: #d60215;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-image: url('../../assets/images/circle-error.png');
        background-size: 100% 100%;
      }
    }
  }
}

/* prevent pull-to-refresh for Safari 16+ */
@media screen and (pointer: coarse) {
  @supports (-webkit-backdrop-filter: blur(1px)) and (overscroll-behavior-y: none)  {
    html {
      min-height: 100.3%;
      overscroll-behavior-y: none;
    }
  }
}
/* prevent pull-to-refresh for Safari 9~15 */
@media screen and (pointer: coarse) {
  @supports (-webkit-backdrop-filter: blur(1px)) and (not (overscroll-behavior-y: none))  {
    html {
      height: 100%;
      overflow: hidden;
    }
    body {
      margin: 0px;
      max-height: 100%; /* or `height: calc(100% - 16px);` if body has default margin */
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
    /* in this case to disable pinch-zoom, set `touch-action: pan-x pan-y;` on `body` instead of `html` */
  }
}
/* prevent pull-to-refresh for Chrome 63+ */
body{
  overscroll-behavior-y: none;

  input {
    font-family: 'TimesNewRoman', sans-serif !important;
  }
}
</style>